export default "__VITE_ASSET__GKn$bFzB__"